/**
 * demo-tenant.ts — S232, M1 (S232-PLAN-DEMO.md v1.2 ; DEC-DEMO-CONTENU-1 « 3a ») : le compte démo isolé se reconnaît au slug de son tenant,
 * qui commence par « demo- » (scripts/compte_demo.py : « demo-cartonnerie-saint-martin », settings.demo = true). Le slug arrive déjà dans
 * /api/v1/auth/me (memberships[].tenant_slug, bridge_database.membership_lister_par_user) : aucun changement du serveur.
 * Fonction pure, exécutée par tests/test_bandeau_demo_js.py (esbuild → node).
 */

export const PREFIXE_SLUG_DEMO = "demo-";
export const TEXTE_BANDEAU_DEMO = "Démo — données fictives";

export function estTenantDemo(membership?: { tenant_slug?: string | null } | null): boolean {
  return typeof membership?.tenant_slug === "string" && membership.tenant_slug.startsWith(PREFIXE_SLUG_DEMO);
}

type MembershipMe = { tenant_id?: number; tenant_slug?: string | null };

/** Le membership du tenant actif dans la réponse de /api/v1/auth/me ({ tenant_id, memberships }), ou null. */
export function membershipActif(me?: { tenant_id?: number; memberships?: MembershipMe[] } | null): MembershipMe | null {
  if (!me || !Array.isArray(me.memberships)) return null;
  return me.memberships.find((m) => m?.tenant_id === me.tenant_id) || null;
}
